import React from 'react'
import { BasicStatsItem } from '../index.styles'

const Energy = () => {
  const link = 'https://app.powerbi.com/view?r=eyJrIjoiY2E3ZDcwYjEtYmQ2Mi00NWJkLWIzMWQtZmExYmI5ODIxZDllIiwidCI6ImU2MjQzNTFhLWViZGItNDUwMi1hNGEzLTRiZWI3OTYxODBlZiIsImMiOjl9'
  return (
    <BasicStatsItem
      style={{
        width: '100%',
        height: '100%',
        border: 'none',
        flex: '1',
        minHeight: 'calc(100vh - 4.4rem)'
      }}>
      <iframe title="Energy iframe" src={link} />
    </BasicStatsItem>
  )
}

export default Energy